// extracted by mini-css-extract-plugin
export default {"wrapper":"GetReady_wrapper__iIK8A","getReadyText":"GetReady_getReadyText__Rj7eY","countdown":"GetReady_countdown__08isV"};